module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Chair1-141357923449c241692e375cde12f1d9.svg";